@if (model$ | async; as model) {
  <div class="cx-page">
    <!-- Invisible Scrolling Anchor for Product List -->
    <div id="product-list-anchor" tabindex="-1"></div>
    <section tabindex="-1" class="cx-page-section" [attr.aria-label]="'productList.productListResults' | cxTranslate">
      <div class="container">
        <div class="row">
          @if (viewMode$ | async; as viewMode) {
            <div class="col-12 col-lg-12">
              <div class="cx-sorting top">
                <div class="row justify-content-center">
                  <div class="col-auto">
                <div class="cx-pagination" [attr.aria-label]="
                    'productList.productSearchPagination' | cxTranslate
                  ">
                      <cx-pagination
                        [pagination]="model.pagination"
                        queryParam="page"
                        fragment="product-list-anchor"
                        [defaultPage]="0">
                      </cx-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <div id="product-results-list" class="cx-product-container">
                @if (viewMode === ViewModes.Grid) {
                  <div class="row">
                    @for (product of model?.products; track product) {
                      <app-custom-product-grid-item [product]="product"
                      class="col-6 col-sm-5 col-md-3"></app-custom-product-grid-item>
                    }
                  </div>
                }
              </div>
              <div class="cx-sorting bottom">
                <div class="row col-12 justify-content-center">
              <div class="col-auto" [attr.aria-label]="
                  'productList.productSearchPagination' | cxTranslate
                ">
                    <div class="cx-pagination">
                      <cx-pagination
                        [pagination]="model.pagination"
                        queryParam="page"
                        fragment="product-list-anchor"
                        [defaultPage]="0">
                      </cx-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="bottom-long-description" [innerHTML]="model?.categoryBottomLongDescription"></div>
        </div>
      </div>
    </section>
  </div>
}